module.exports = __webpack_public_path__ + "static/media/patreon.0f4a461a.svg";